import BSWheatPastaProduct from 'models/BSWheatPastaProduct'

export const brandNameOptions = [
  {
    value: '',
    label: 'Brand Name',
    isDisabled: true,
  },
  { value: 'Allegra', label: 'Allegra' },
  { value: 'Barilla', label: 'Barilla' },
  { value: 'Essential Everyday', label: 'Essential Everyday' },
  { value: 'Full Circle Market Organic', label: 'Full Circle Market Organic' },
  { value: 'Good & Gather', label: 'Good & Gather' },
  { value: 'Great Value', label: 'Great Value' },
  { value: 'Kroger', label: 'Kroger' },
  { value: 'O Organics', label: 'O Organics' },
  { value: "Raley's", label: "Raley's" },
  { value: 'Ronzoni', label: 'Ronzoni' },
  { value: 'Signature Select', label: 'Signature Select' },
  { value: 'Simple Truth Organic', label: 'Simple Truth Organic' },
  { value: 'Stater Bros.', label: 'Stater Bros.' },
  { value: 'Wild Harvest Organic', label: 'Wild Harvest Organic' },
  { value: 'WinCo Foods', label: 'WinCo Foods' },
]

export const packagingInitialState = {
  category: BSWheatPastaProduct.category,
  subCategory: BSWheatPastaProduct.subCategory,
  WholeWheatFlour: BSWheatPastaProduct.WholeWheatFlour,
  PastaShape: BSWheatPastaProduct.PastaShape,
  Size: BSWheatPastaProduct.Size,
}
